import { render, staticRenderFns } from "./ReturnMoveToMainModal.vue?vue&type=template&id=657e494d&"
import script from "./ReturnMoveToMainModal.vue?vue&type=script&lang=js&"
export * from "./ReturnMoveToMainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports